export default __webpack_public_path__ + "static/media/close_green.26192ac4.svg";